import { Box } from "../../components/primitives";
import { styled } from "../../stitches.config";

export const SideMenuWrapper = styled(Box, {
  width: 250,
  borderRight: "1px solid #cbd5e1",
  minHeight: "100vh",
  backgroundColor: "#f8f8ff",
  padding: 20,
});
